<template>
  <div class="mc-rail">
    <div ref="track" class="mc-rail-track">
      <div
        v-for="(label, i) in steps"
        :key="label"
        class="mc-rnode"
        :class="{
          'is-done': i + 1 < activeStep,
          'is-active': i + 1 === activeStep,
        }"
      >
        <div class="mc-rdot">
          <svg
            v-if="i + 1 < activeStep"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <template v-else>{{ i + 1 }}</template>
        </div>
        <div class="mc-rlabel">{{ label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressRail',
  props: {
    steps: { type: Array, required: true },
    activeStep: { type: Number, required: true },
  },
  watch: {
    activeStep() {
      this.$nextTick(this.scrollActiveIntoView)
    },
  },
  mounted() {
    this.scrollActiveIntoView()
  },
  methods: {
    scrollActiveIntoView() {
      const track = this.$refs.track
      const el = track && track.children[this.activeStep - 1]
      if (el)
        el.scrollIntoView({
          inline: 'center',
          block: 'nearest',
          behavior: 'smooth',
        })
    },
  },
}
</script>

<style scoped>
.mc-rail {
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  padding: 10px 0 8px;
}

.mc-rail-track {
  display: flex;
  gap: 0;
  overflow-x: auto;
  scrollbar-width: none;
  padding: 0 14px;
}

.mc-rail-track::-webkit-scrollbar {
  display: none;
}

.mc-rnode {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 62px;
  position: relative;
}

.mc-rnode::before,
.mc-rnode::after {
  content: '';
  position: absolute;
  top: 12px;
  height: 2px;
  background: #d9dbe9;
}

.mc-rnode::before {
  left: 0;
  right: 50%;
}

.mc-rnode::after {
  left: 50%;
  right: 0;
}

.mc-rnode:first-child::before,
.mc-rnode:last-child::after {
  display: none;
}

.mc-rnode.is-done::before,
.mc-rnode.is-done::after,
.mc-rnode.is-active::before {
  background: #0066cc;
}

.mc-rdot {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  position: relative;
  z-index: 1;
  background: #fff;
  border: 2px solid #d9dbe9;
  color: #6e7191;
  font-size: 11.5px;
  font-weight: 700;
}

.mc-rnode.is-active .mc-rdot,
.mc-rnode.is-done .mc-rdot {
  background: #0066cc;
  border-color: #0066cc;
  color: #fff;
}

.mc-rlabel {
  margin-top: 5px;
  font-size: 9.5px;
  line-height: 1.2;
  text-align: center;
  color: #6e7191;
  font-weight: 500;
}

.mc-rnode.is-active .mc-rlabel {
  color: #003087;
  font-weight: 600;
}

.mc-rnode.is-done .mc-rlabel {
  color: #6e7191;
}
</style>
